// extracted by mini-css-extract-plugin
export var addToCartBtn = "style-mod--add-to-cart-btn--042a0";
export var advancedProductGroup = "style-mod--advanced-product-group--5b3e8";
export var benefits = "style-mod--benefits--4eff0";
export var box = "style-mod--box--6f45d";
export var cartBtn = "style-mod--cart-btn--b62b5";
export var clipStar = "style-mod--clip-star--8b4dc";
export var compAtPrice = "style-mod--comp-at-price--06965";
export var container = "style-mod--container--2aaa9";
export var contentCol = "style-mod--content-col--dd4a3";
export var freeReturns = "style-mod--free-returns--c6c2c";
export var imagesCol = "style-mod--images-col--bb92d";
export var imgBox = "style-mod--img-box--9f4e1";
export var isDesktop = "style-mod--is-desktop--275e0";
export var isMobile = "style-mod--is-mobile--c6432";
export var mainTitle = "style-mod--main-title--3a219";
export var multiple = "style-mod--multiple--7870c";
export var pdpPriceBox = "style-mod--pdp-price-box--4b774";
export var productDataView = "style-mod--product-data-view--c1a3d";
export var productPrice = "style-mod--product-price--c9ae1";
export var productTitle = "style-mod--product-title--fc9e0";
export var ratingText = "style-mod--rating-text--21836";
export var selected = "style-mod--selected--08cab";
export var singleProduct = "style-mod--single-product--aab5e";
export var singleProductContent = "style-mod--single-product-content--01d28";
export var specificBadgeProd = "style-mod--specific-badge-prod--8b3b8";
export var tooltipInfo = "style-mod--tooltip-info--379e2";
export var voucherBadge = "style-mod--voucher-badge--7b52e";